import { useState, useEffect } from 'react';

function classifyWidth(width) {
  const w = Number(width) || 0;
  if (w > 0 && w < 640) return 'mobile';
  if (w >= 640 && w < 1024) return 'tablet';
  return 'desktop';
}

/**
 * Device bucket for ad targeting (must match server `AdCampaign.targeting.devices`).
 */
export function useAdDevice() {
  const [device, setDevice] = useState(() =>
    typeof window !== 'undefined' ? classifyWidth(window.innerWidth) : 'desktop',
  );

  useEffect(() => {
    function update() {
      setDevice(classifyWidth(window.innerWidth));
    }
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return device;
}
